module.exports = __webpack_public_path__ + "static/media/om_beard_long_diamond__v.fa37851a.png";